var exports = {
  "J5": "Octicon_0__lnAzgX",
  "yU": "ActionMenu_Overlay_0__xDvEgv",
  "U3": "ActionList_0__C7EIdo",
  "Ko": "ActionList_Item_0__iC3Hiu",
};

module.exports = exports;
